import { useQuery } from '@tanstack/solid-query'
import ky from 'ky'

// Mirror the focus-pass pattern: a single `['timestamp']` Solid Query keeps
// server "now" in ms fresh by re-fetching `/time.js?` every 60s. The final
// response URL carries `?ts=<unix_seconds>`, which we parse back out.
// Seeded at module load by `lib/query-client.ts` from the `ts` URL param.
export function useTimestamp() {
  return useQuery(() => ({
    queryKey: ['timestamp'] as const,
    queryFn: async () => {
      const res = await ky.get('/time.js?')
      const tsParam = new URL(res.url).searchParams.get('ts')
      if (!tsParam) throw new Error('timestamp response has no ts')
      const tsNum = Number(tsParam)
      if (!Number.isFinite(tsNum) || tsNum <= 0) {
        throw new Error(`timestamp response has invalid ts: ${tsParam}`)
      }
      return tsNum * 1000
    },
    refetchInterval: 60_000,
    staleTime: Infinity,
  }))
}
